/**
 * 设计公司模块路由
 */
export const dayangRoutes = [
  // 销售合同模板
  // {
  //   path: 'htmb',
  //   component: () => import('@/views/dayang/Htmb.vue')
  // },
]